<script>
// import Vue from 'vue'
// Import UI components
import Layout from '@layouts/report.vue'
// import Grid from '@components/grid.vue'

// Import ThirdParty UI Components
import MultiAxisChart from '@components/charts/multiAxisChart.vue'
// Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
// Import Deps
import axios from 'axios'
import moment from 'moment'
import ECharts from 'vue-echarts'


// import _ from 'underscore'

// Import helpers
// import { sortData, pipe } from '@utils/helpers.js'

// export const remapData = (data) =>
//   data.map((obj, index) => {
//     return { value: obj[key1], name: obj[key2] }
//   })

export const pipe = (...functions) => (value) => {
  return functions.reduce((currentValue, currentFunction) => {
    return currentFunction(currentValue)
  }, value)
}

const getChartConfig = () => {
  return {
    toolbox: {
      feature: {
        dataZoom: {
          yAxisIndex: 'none',
        },
        restore: {},
        saveAsImage: {},
      },
    },
    tooltip: {
      trigger: 'axis',

      axisPointer: {
        type: 'cross',
        animation: false,
      },
    },
    dataZoom: [
      {
        show: true,
        start: null,
        end: null,
        type: 'inside',
      },
    ],
    legend: {
      data: ['Flights', 'Checked Passengers', 'Checked Baggage'],

      top: 40,
    },
    xAxis: {
      type: 'time',

      splitLine: {
        show: true,
      },

      axisLabel: {
        formatter: function(value) {
          return moment(value).format('HH:mm')
        },
      },
    },
    yAxis: [
      {
        type: 'value',
        name: 'Pax/Transactions',
        splitLine: {
          show: true,
        },
      },

      {
        type: 'value',
        offset: 0,
        name: 'Flts',
        max: 5,
        splitLine: {
          show: false,
        },
      },
    ],
    series: [
      {
        name: 'Total Agents',
        yAxisIndex: 1,

        type: 'line',
        showSymbol: true,
        hoverAnimation: false,
        data: [],
        smooth: false,

        lineStyle: {
          width: 1,
          opacity: 0.5,
        },
        itemStyle: {
          color: 'grey',
        },
        areaStyle: {
          opacity: 0.5,
          color: '#e3e4e5',
        },
      },
      {
        name: 'Total Passengers ',
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
        type: 'bar',
        showSymbol: false,
        hoverAnimation: true,
        data: [],
        barGap: '-100%',

        itemStyle: {
          barBorderRadius: 10,
          color: new ECharts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              color: '#00878f',
              offset: 1,
            },
            {
              offset: 0,
              color: '#0099a3',
            },
          ]),
        },
        lineStyle: {
          width: 0,
        },
        markLine: {
          data: [{ type: 'average', name: 'Average Passenger Count' }],
          label: {
            textStyle: {
              fontSize: 18,
              fontWeight: 600,
            },
          },
        },
        markPoint: {
          data: [
            {
              type: 'max',
              name: 'Hightest Passenger Count',
            },
            {
              type: 'min',
              name: 'Lowest Passenger Count',
            },
          ],
          label: {
            textStyle: {
              color: '#fff',
              fontWeight: 600,
            },
          },
        },
      },
      {
        name: 'Total Transactions',
        // areaStyle: {},
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
        type: 'bar',
        showSymbol: false,
        hoverAnimation: false,
        data: [],

        // sampling: 'average',
        itemStyle: {
          color: 'black',
          opacity: 0.3,
        },
        lineStyle: {
          width: 0,
        },
      },
    ],
  }
}

function getDates(startDate, endDate) {
  var dateArray = []
  var currentDate = moment(startDate)
  var stopDate = moment(endDate)
  while (currentDate <= stopDate) {
    dateArray.push(
      moment(currentDate)
        .format('DDMMMYY')
        .toUpperCase()
    )
    currentDate = moment(currentDate).add(1, 'days')
  }
  return dateArray
}

const formatUsageData = (data, xKey, yKey) => {
  // Data needs to be sorted for eChats
  data = data.sort((a, b) => {
    var x = a[xKey]
    var y = b[xKey]
    return x < y ? -1 : x > y ? 1 : 0
  })

  const finalData = data.map((obj) => {
    const x = {
      name: moment(obj[xKey]).toDate(),
      value: [moment(obj[xKey]).format('YYYY/MM/DD HH:mm'), obj[yKey]],
    }
    return x
  })
  return finalData
}

export default {
  page() {
    return {
      title: 'Checkin Report',
      meta: [
        {
          name: 'description',
          content: ``,
        },
      ],
    }
  },
  components: {
    Layout,

    MultiAxisChart,
    Loading,
  },
  props: {},
  data() {
    return {
      chart1Data: [],
      chart2Data: [],
      chart1Options: {},
      chart2Options: {},
      lastUpdated: [
        { type: 'checkinTotals', timestamp: null },
        { type: 'boardingTotals', timestamp: null },
      ],
      isLoading: false,
      error: null,
      sideBarVisible: true,
      params: {},
      sortKey: 'StdDate',
      paramsSchema: [
        {
          fieldType: 'MultiSelect',
          placeholder: 'Select Carriers',
          multi: true,
          value: null,
          name: 'carrier',
          label: 'Carriers',
        },
      ],
    }
  },

  computed: {
    carrierChoice() {
      return this.$store.getters['auth/getCarrierChoice']
    },

    dateRange() {
      return this.$store.getters['report/getSelectedDateRange']
    },
    datesArray() {
      return getDates(
        this.dateRange.startDate,
        this.dateRange.endDate
      ).reverse()
    },
  },
  watch: {
    chart1Data: {
      immediate: false,
      handler(data) {
        this.chart1Options.xAxis.min = moment(this.dateRange.startDate)
          .startOf('day')
          .toDate()
        this.chart1Options.xAxis.max = moment(this.dateRange.endDate)
          .endOf('day')
          .toDate()
        this.chart2Options.xAxis.min = moment(this.dateRange.startDate)
          .startOf('day')
          .toDate()
        this.chart2Options.xAxis.max = moment(this.dateRange.endDate)
          .endOf('day')
          .toDate()
        this.chart1Options.series[0].data = data[0]
        this.chart1Options.series[1].data = data[1]
        this.chart1Options.series[2].data = data[2]
      },
    },
    chart2Data: {
      immediate: false,
      handler(data) {
        this.chart2Options.xAxis.min = moment(this.dateRange.startDate)
          .startOf('day')
          .toDate()
        this.chart2Options.xAxis.max = moment(this.dateRange.endDate)
          .endOf('day')
          .toDate()
        this.chart2Options.series[0].data = data[0]
        this.chart2Options.series[1].data = data[1]
        this.chart2Options.series[2].data = data[2]
      },
    },
    dateRange: {
      deep: true,
      immediate: true,
      handler(dateRange) {
        this.getData()
      },
    },
    params: {
      deep: true,
      handler() {
        this.getData()
      },
    },
    selectedKey: {
      handler() {
        this.getData()
      },
    },
  },
  beforeCreate() {
    this.$store.dispatch('report/SET_SELECTED_DATE_RANGE', {
      startDate: moment().add(-1, 'd'),
      endDate: moment().add(-1, 'd'),
    })
  },
  mounted() {
    // this.getData()
    this.paramsSchema[0].options = this.carrierChoice
    this.chart1Options = getChartConfig()
    this.chart2Options = getChartConfig()
  },
  methods: {
    formatUsageData: formatUsageData,
    dataZoom(id, zoom) {
      switch (id) {
        case 'ckdChart':
          this.chart2Options.dataZoom[0].start = zoom.batch[0].start
          this.chart2Options.dataZoom[0].end = zoom.batch[0].end
          break
        case 'brdChart':
          this.chart1Options.dataZoom[0].start = zoom.batch[0].start
          this.chart1Options.dataZoom[0].end = zoom.batch[0].end
          break
        default:
          break
      }
    },
    moment(date, format) {
      return moment(date).format(format)
    },
    sortData(data) {
      return data.sort((a, b) => {
        var x = a[this.sortKey]
        var y = b[this.sortKey]
        return x < y ? -1 : x > y ? 1 : 0
      })
    },
    getData() {
      this.isLoading = true

      this.error = null
      //   Setup Report Params
      const startDate = moment(this.dateRange.startDate).format('DDMMMYY')
      const endDate = moment(this.dateRange.endDate).format('DDMMMYY')
      const carriers =
        this.params && this.params.carrier
          ? this.params.carrier.join(',')
          : 'all'
      //   @@TODO - Config file for webapi address!!

      axios
        .get(
          `${this.$config.apiBaseUrl}agentTotals/ckd/carrier/${carriers}/start/${startDate}/end/${endDate}/timeperiod/10`
        )
        .then((response) => {
          const data = response.data.Results[0]
          // Update the timestamp
          const checkinTotals = this.lastUpdated.findIndex(
            (obj) => obj.type === 'checkinTotals'
          )
          this.lastUpdated[checkinTotals].timestamp = response.data.Timestamp
          const TotalTransactions = this.formatUsageData(
            data,
            'DatePeriod',
            'TotalTransactions'
          )
          const TotalAgent = this.formatUsageData(
            data,
            'DatePeriod',
            'TotalAgent'
          )
          const TotalPax = this.formatUsageData(data, 'DatePeriod', 'TotalPax')
          this.chart1Data = [TotalAgent, TotalPax, TotalTransactions]
        })
        .catch((error) => {
          this.error = error.response
          console.log('here ---> ', error)
        })
        .finally(() => (this.isLoading = false))

      axios
        .get(
          `${this.$config.apiBaseUrl}agentTotals/brd/carrier/${carriers}/start/${startDate}/end/${endDate}/timeperiod/10`
        )
        .then((response) => {
          const data = response.data.Results[0]
          // Update the timestamp
          const checkinTotals = this.lastUpdated.findIndex(
            (obj) => obj.type === 'boardingTotals'
          )
          this.lastUpdated[checkinTotals].timestamp = response.data.Timestamp
          const TotalTransactions = this.formatUsageData(
            data,
            'DatePeriod',
            'TotalTransactions'
          )
          const TotalAgent = this.formatUsageData(
            data,
            'DatePeriod',
            'TotalAgent'
          )
          const TotalPax = this.formatUsageData(data, 'DatePeriod', 'TotalPax')
          this.chart2Data = [TotalAgent, TotalPax, TotalTransactions]
        })
        .catch((error) => {
          this.error = error.response
          console.log('here ---> ', error)
        })
        .finally(() => (this.isLoading = false))
    },
  },
}
</script>

<template>
  <Layout
    :params-schema="paramsSchema"
    :params="params"
    :last-updated="lastUpdated"
    :error="error"
  >
    <div class="mr-1 mt-1 ml-1 full">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-10">
              <h5 class="card-title">Check-in Report</h5>
              <p
                >This report shows the shows the total number of check-in
                transactions, checked in passengers and active agents. Use your
                mouse wheel to zoom. Click and hold to drag the chart forward or
                backwards in time.</p
              >
            </div>
            <div class="col-4 text-right"></div>
            <div class="col-2 text-right"> </div>
          </div>

          <MultiAxisChart
            id="ckdChart"
            ref="ckdChart"
            :chart-options="chart1Options"
            @dataZoom="dataZoom"
          ></MultiAxisChart>
          <h5 class="card-title">Boarding Report</h5>
          <MultiAxisChart
            id="brdChart"
            ref="brdChart"
            :chart-data="chart2Data"
            :chart-options="chart2Options"
            @dataZoom="dataZoom"
          ></MultiAxisChart>
        </div>
      </div>
    </div>
    <Loading></Loading>
  </Layout>
</template>

<style scoped></style>
